<template>
  <v-menu
    v-model="dialog"
    min-width="20rem"
    max-width="25rem"
    open-on-hover
    :nudge-width="200"
    :offset-x="$vuetify.breakpoint.smAndUp"
    :offset-y="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <tr v-on="on" style="padding-bottom: 2px;">
        <slot></slot>
      </tr>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <span class="font-capitalize subtitle-1 ml-2">{{
            getProductName
          }}</span>
        </v-row>
      </v-card-title>
      <v-card-text v-if="loading">
        <v-row align="center" justify="center" no-gutters class="my-3">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Date d'expiration</span>
          <span class="heading-6"></span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Dernière saisie</span>
          <span class="heading-6"></span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Date de la production</span>
          <span class="heading-6"></span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Consommation jusqu'à expiration</span>
          <span class="heading-6"></span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Production jusqu'à expiration</span>
          <span class="heading-6"></span>
        </v-row>

        <v-row class="mt-3" align="center" justify="space-between">
          <v-btn
            text
            small
            @click="
              $router.push({ name: 'StatisticsDetails', params: { id: id } })
            "
          >
            <v-icon small left>far fa-chart-bar</v-icon>
            Détails
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { api } from "@/api";
import { round10 } from "round10";
import { mapGetters } from "vuex";
export default {
  name: "WasteSummaryDialog",
  props: {
    id: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes"]),
    getProductName() {
      const p = this.getProducts.find(x => x.id === this.productId);
      if (p) {
        return p.nom;
      } else {
        return "";
      }
    },
    getProduction() {
      return round10(
        this.transactions
          .map(x => Number(x.quantity))
          .filter(x => x > 0)
          .reduce((a, b) => a + b, 0),
        -2
      );
    },
    getConsomation() {
      return round10(
        this.transactions
          .map(x => Number(x.quantity))
          .filter(x => x < 0)
          .reduce((a, b) => a + b, 0),
        -2
      );
    }
  },
  data() {
    return {
      waste: undefined,
      wasteId: undefined,
      productId: undefined,
      dialog: false,
      loading: false
    };
  },
  methods: {
    openDialog() {
      this.wasteId = this.id;
      this.dialog = true;
      this.getData();
    },
    async getData() {
      try {
        this.loading = true;
        this.waste = await api.retrieveInventoryTransaction(this.wasteId);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.wasteId = this.id;
        if (this.loading === false) this.getData();
      }
    }
  }
};
</script>

<style></style>
